import merge from 'lodash/merge';
import { ANALYTICS_CATEGORY_NAVIGATION } from '../analytics/Events';
const getScreenViewEvent = _ref => {
  let {
    marketplaceContext,
    payload,
    baseAttributes = {},
    analyticsRouteParams = {}
  } = _ref;
  const {
    attributes: payloadAttributes,
    eventType: {
      name,
      details
    }
  } = payload;
  const {
    attributes: contextAttributes
  } = marketplaceContext;
  const attributes = merge({}, analyticsRouteParams, baseAttributes, contextAttributes, payloadAttributes);
  return {
    name: name,
    details,
    attributes
  };
};
const getNonScreenEvent = _ref2 => {
  let {
    marketplaceContext,
    payload,
    source,
    baseAttributes = {}
  } = _ref2;
  const {
    tags = [],
    eventType: {
      actionSubject,
      action
    },
    actionSubjectId,
    objectId,
    objectType,
    source: payloadSource,
    attributes: payloadAttributes
  } = payload;
  const {
    attributes: contextAttributes,
    properties: contextProperties
  } = marketplaceContext;
  const attributes = merge({}, baseAttributes, contextAttributes, payloadAttributes);
  const baseProperties = {
    category: ANALYTICS_CATEGORY_NAVIGATION,
    source: (payloadSource === null || payloadSource === void 0 ? void 0 : payloadSource.name) || (source === null || source === void 0 ? void 0 : source.name) || contextProperties.source,
    tags
  };

  // containerId, containerType, source cannot be overridden by the payload
  const payloadProperties = {
    action,
    actionSubject,
    actionSubjectId,
    objectId,
    objectType
  };
  return merge({}, baseProperties, contextProperties, payloadProperties,
  // attributes were previously merged
  {
    attributes
  });
};
export { getNonScreenEvent, getScreenViewEvent };